const analyticsTypes = {
  MANAGE_USERS_VIEW: 'user_Manage_View',
  REVOKE_USER_ACCESS_SUBMIT: 'user_RevokeAccess_Submit',
  INVITE_USER_SUBMIT: 'user_InviteUser_Submit',
  EDIT_USER_PERMISSIONS_SUBMIT: 'user_EditPermissions_Submit'
};

const analyticsActions = [{
  type: analyticsTypes.MANAGE_USERS_VIEW,
}, {
  type: analyticsTypes.REVOKE_USER_ACCESS_SUBMIT,
}, {
  type: analyticsTypes.INVITE_USER_SUBMIT,
}, {
  type: analyticsTypes.EDIT_USER_PERMISSIONS_SUBMIT,
}];

export {
  analyticsTypes,
  analyticsActions
};
